module.exports = __webpack_public_path__ + "d16d814f43c10883cf10a514ed0f22f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/features/screens/fitness/medium.png
// module id = 1812
// module chunks = 1